<button type="button" class="btn user-btn star-button"
        title="Add sticker"
        popoverClass="sticker-popover cs-popover"
        placement="{{userIndex < 6 ? 'right-top' : 'right-bottom'}}"
        [ngbPopover]="starPanelPopoverTemplate"
        *ngIf="userListView">+
</button>

<ng-template #starPanelPopoverTemplate>
  <div class="star-panel-popover d-flex flex-wrap">
        <span *ngFor="let sticker of classroom.stickers">
            <button type="button" (click)="addSticker(sticker)" class="{{'sticker-' + sticker}}">
                <img [src]="'assets/img/stickers/40x40/' + sticker + '-icon.png'" alt="{{sticker}}" title="{{sticker}}">
            </button>
        </span>
  </div>
</ng-template>

<div class="btn-group dropdown"
     [ngClass]="{'show-on-top': userIndex | isInLastRow:studentsCount:classroom.isStudentsSectionCollapsed}"
     bsDropdown #dropdown="bs-dropdown"
     [isOpen]="status.isOpenStarButtonVideoList"
     *ngIf="!userListView">
  <button type="button" class="button star-button"
          title="Add sticker"
          bsDropdownToggle>+
  </button>
  <div class="dropdown-menu" *dropdownMenu>
    <div class="star-panel-popover d-flex flex-wrap">
      <span *ngFor="let sticker of classroom.stickers">
          <button type="button" (click)="addSticker(sticker)" class="{{'sticker-' + sticker}}">
              <img [src]="'assets/img/stickers/40x40/' + sticker + '-icon.png'" alt="{{sticker}}" title="{{sticker}}">
          </button>
      </span>
    </div>
  </div>
</div>
